import { FC } from 'react';

import { Box, Button, CardVariants, Paragraph } from '@common/components';
import { Variants } from '@/common/types';

import { PatientProfileOverviewCardProps } from './PatientProfileOverviewCard.types';
import {
  StyledActionsContainer,
  StyledApptInfoContainer,
  StyledApptInfoTitle,
  StyledApptInfoValue,
  StyledCalendarIcon,
  StyledCardContainer,
  StyledContentContainer,
  StyledHeader,
  StyledSeparator,
  StyledTitle,
} from './PatientProfileOverviewCard.styles';
import { useTranslation } from 'react-i18next';
import { BLANK_VALUE, GENETIC_COUNSELING_TRANSLATION } from '@/modules/genetic-counseling/constants';

const PatientProfileOverviewCard: FC<PatientProfileOverviewCardProps> = ({
  actions,
  children,
  mainInfo,
  notes,
  title,
}) => {
  const { t } = useTranslation(GENETIC_COUNSELING_TRANSLATION);
  return (
    <StyledCardContainer variant={CardVariants.SECONDARY} data-testid="counseling-status-card">
      <StyledHeader>
        <StyledCalendarIcon />
        <StyledTitle data-testid="counseling-status-card-title">{title}</StyledTitle>
      </StyledHeader>
      <StyledContentContainer>
        {mainInfo?.map((item) => (
          <StyledApptInfoContainer key={item.id}>
            <StyledApptInfoTitle data-testid={`counseling-status-card-info-${item.id}-label`}>
              {item.label}
            </StyledApptInfoTitle>
            <StyledApptInfoValue data-testid={`counseling-status-card-info-${item.id}-value`}>
              {item.value ? item.value : BLANK_VALUE}
            </StyledApptInfoValue>
          </StyledApptInfoContainer>
        ))}
      </StyledContentContainer>
      {notes && (
        <>
          <StyledSeparator />
          <Box>
            <Paragraph css={{ textAlign: 'left' }} data-testid="counseling-status-card-notes">
              {t('notes')} {notes}
            </Paragraph>
          </Box>
        </>
      )}
      {children && (
        <>
          <StyledSeparator />
          {children}
        </>
      )}
      {!!actions?.length && (
        <>
          <StyledSeparator />
          <StyledActionsContainer>
            {actions?.map((action) => (
              <Button
                key={action.id}
                variant={Variants.SECONDARY}
                onClick={action.onClick}
                id={`counseling-status-card-action-${action.id}`}
              >
                {action.label}
              </Button>
            ))}
          </StyledActionsContainer>
        </>
      )}
    </StyledCardContainer>
  );
};

export default PatientProfileOverviewCard;
